import TinyEditorModal from '../TinyEditorModal'
import { Link } from 'react-router'
import IconSVG from 'svg-inline-react'
import cx from 'classnames'

import Avatar from 'shared-web/src/components/Avatar'

import { getUserDisplayName } from 'app/modules/user/utils'

import femalePlaceholderSrc from '!svg-inline?removeTags=true!images/svg/female-placeholder.svg'
import team2Src from '!svg-inline?removeTags=true!images/svg/team-2.svg'

import './style.styl'

const CalendarPopoverSteps = {
  SELECT: 'select',
  CONFIRM: 'confirm',
}

const DYNAMIC_CALENDAR = 'DYNAMIC_CALENDAR'

class CalendarPopoverSelect extends React.Component {
  render() {
    const { usersWithCalendar,
      usersWithoutCalendar,
      onDynamicCalSelect,
      search,
      onSearchChange,
      onPropertySelect,
      currentUser,
      currentUserHasCalendarConnected,
      enableDynamicCalendarLink,
      disableDynamicCalendarLink,
      showCurrentUser,
      isSearching
    } = this.props

    return (
      <div className="modal-selector-container">
        <div className="modal-selector-section modal-selector-section-top drift-form">
          <input
            className="modal-selector-search-input"
            type="text"
            value={search}
            onChange={onSearchChange}
            placeholder="Search"
          />
        </div>
        <div className="tiny-calendar-modal-options">
          {!!enableDynamicCalendarLink && !disableDynamicCalendarLink &&
            !isSearching && (
              <div className={cx('tiny-calendar-modal-option')} onClick={onDynamicCalSelect}>
                <div className="tiny-calendar-dynamic-option-icon">
                  <IconSVG src={team2Src} />
                </div>
                <span className="tiny-calendar-modal-option-name">Insert dynamic calendar based email sender</span>
              </div>
            )}
          {showCurrentUser && (
            <div
              className={cx('tiny-calendar-modal-option', {
                'tiny-calendar-modal-option-disabled': !currentUserHasCalendarConnected,
              })}
              onClick={() => (currentUserHasCalendarConnected ? onPropertySelect(currentUser) : null)}
            >
              <Avatar size="small" user={currentUser} />
              <span className="tiny-calendar-modal-option-name">{getUserDisplayName(currentUser)}</span>
              {!currentUserHasCalendarConnected && (
                <a href="/meetings/?source=email-playbook-editor" className="link dsg-Regular">
                  Connect your calendar
                </a>
              )}
            </div>
          )}
          {usersWithCalendar.map(user => (
            <div key={user} className="tiny-calendar-modal-option" onClick={() => onPropertySelect(user)}>
              <Avatar size="small" user={user} />
              <span className="tiny-calendar-modal-option-name">{getUserDisplayName(user)}</span>
            </div>
          ))}
          {usersWithoutCalendar.size > 0 && (
            <div className="tiny-calendar-modal-options-header">These calendars are not connected.</div>
          )}
          {usersWithoutCalendar.map(user => (
            <div key={user} className="tiny-calendar-modal-option tiny-calendar-modal-option-disabled">
              <Avatar size="small" user={user} />
              <span className="tiny-calendar-modal-option-name">{getUserDisplayName(user)}</span>
            </div>
          ))}
          {usersWithoutCalendar.size === 0 &&
            usersWithCalendar.size === 0 &&
            !showCurrentUser && (
              <div className="modal-selector-empty-options">
                <IconSVG src={femalePlaceholderSrc} />
                <p>There is no one on your team by that name.</p>
              </div>
            )}
        </div>
      </div>
    )
  }
}

const CalendarPopoverConfirm = ({
  onDefaultCancel,
  onDefaultConfirm,
  selectedUser,
  linkText,
  onDefaultChange,
  calendarProfileLoading,
  isOutboundSequencePlaybook
}) => (
  <div className="modal-selector-container">
    <div className="modal-selector-section modal-selector-section-top">
      {selectedUser === DYNAMIC_CALENDAR &&
        <div className="modal-selector-user-preview">
          <span className="tiny-calendar-dynamic-option-icon">
            <IconSVG src={team2Src} />
          </span>
          <span className="modal-selector-user-preview-name">Dynamic based on email sender</span>
        </div>
      }
      {selectedUser !== DYNAMIC_CALENDAR &&
        <div className="modal-selector-user-preview">
          <Avatar size="small" user={selectedUser} />
          <span className="modal-selector-user-preview-name">{getUserDisplayName(selectedUser)}</span>
        </div>
      }
      {!isOutboundSequencePlaybook &&
        <div onClick={onDefaultCancel} className="link preview-edit-link">
          Change
        </div>
      }
    </div>
    <div className="drift-form modal-calendar-confirm-form">
      <label className="default-form-label">Link text:</label>
      <input type="text" value={linkText} onChange={onDefaultChange} />
      <p className="default-form-extra-details">
        Choose what text should appear for this link
      </p>
    </div>
    <div className="modal-selector-section modal-selector-section-bottom">
      <div
        onClick={onDefaultConfirm}
        disabled={!!calendarProfileLoading}
        className="modal-selector-section-button drift-button drift-button-primary"
      >
        Insert
      </div>
      <div onClick={onDefaultCancel} className="modal-selector-section-button drift-button drift-button-secondary">
        Cancel
      </div>
    </div>
  </div>
)

const CalendarLinkModal = ({ popoverStep, hideCalendarLinkModal, ...rest }) => (
  <TinyEditorModal title={"Insert Calendar Link"} onClose={hideCalendarLinkModal}>
    <div className="playbook-calendar-link-modal">
      <div className={cx('tiny-calendar-modal')}>
        {popoverStep === CalendarPopoverSteps.SELECT && <CalendarPopoverSelect {...rest} />}
        {popoverStep === CalendarPopoverSteps.CONFIRM && <CalendarPopoverConfirm {...rest} />}
      </div>
    </div>
  </TinyEditorModal>
)


export default CalendarLinkModal



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EditorCalendarLinkModal/component.js